import React from "react";
import { Provider } from "react-redux";
import { RootQueryProvider } from "./src/context/RootQuery/RootQuery";
import store from "./src/state/store";
import { setupCUIConfig } from "@caesars-ui/core";

// CSS
import "./src/css/index.css";
import "@caesars-ui/core/dist/css/caesars-ui.css";
require("prismjs/themes/prism-tomorrow.css");

setupCUIConfig({
  imagesDir: "/cui/icons"
});


export const wrapRootElement = ({ element }) => {
  return (
    <Provider store={store}>
      <RootQueryProvider>{element}</RootQueryProvider>
    </Provider>
  );
};
